export default class Youtube {
    config = {};

    constructor(elem, config) {
        this.config = {...this.config, ...config};
        this.iframe = elem.querySelector('iframe');
        this.items = Array.from(elem.querySelectorAll('.youtube-item'));

        this.init();
    }

    init() {
        // eslint-disable-next-line no-console
        if (this.iframe && this.items.length > 0) {
            if (window.hasYoutube === true) {
                this.setUrl(this.items[0]);

                this.items[0].classList.add('active-video');

                this.items.forEach((item) => {
                    item.addEventListener('click', () => {
                        this.setUrl(item, true);
                    });
                });
            }
        }
    }

    setUrl(item, autoplay = false) {
        if (item.dataset.id) {
            if (autoplay) {
                // eslint-disable-next-line max-len
                this.iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            } else {
                // eslint-disable-next-line max-len
                this.iframe.allow = 'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            }

            this.iframe.src = `https://www.youtube-nocookie.com/embed/${item.dataset.id}?rel=0&autoplay=1`;

            this.items.forEach((i) => {
                if (i.dataset.id === item.dataset.id) {
                    i.classList.add('active-video');
                } else {
                    i.classList.remove('active-video');
                }
            });
        }
    }
}
